// extracted by mini-css-extract-plugin
export default {"main":"DetailMap_main__lET3N","box_map":"DetailMap_box_map__Z-EF3"};